<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading_d">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="masterInfoAssets" class="nav nav-tabs" role="tablist">

          <li class="nav-item" role="presentation">
            <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
              {{ $t("content.mterminate") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab2" aria-selected="false" @click="onClickTab('2')">
              {{ $t("content.meditpg") }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button id="tab3-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab3" aria-selected="false" @click="onClickTab('3')">
              {{ $t("content.editimg") }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button id="tab3-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab3" aria-selected="false" @click="onClickTab('4')">
              Lunch Q
            </button>
          </li>
           <li class="nav-item" role="presentation">
            <button id="tab3-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab3" aria-selected="false" @click="onClickTab('5')">
              Re Lunch Q
            </button>
          </li>
        </ul>

        <div id="bmTabContent" class="tab-content">
          <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.mterminate") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mgroup") }}</label>
                    <select class="form-select" v-model="search_groupt" @change="shoplist">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listgroup" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mshoup") }}</label>
                    <select class="form-select" v-model="search_shopt" :disabled="search_groupt === ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listshop_t" :key="opt1" :value="a.uid">
                        {{ a.nameTh }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.queue") }}</label>
                    <select class="form-select" v-model="queue_searcht"
                      :disabled="search_groupt === '' || search_shopt === ''">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option value="Q01">Q01</option>
                      <option value="Q02">Q02</option>
                      <option value="Q03">Q03</option>
                      <option value="Q04">Q04</option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.trans") }}</label>
                    <select class="form-select" v-model="ty_searcht"
                      :disabled="search_groupt === '' || search_shopt === ''">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option value="PAWN">{{ $t('content.actpawn1') }}</option>
                      <option value="INTEREST">{{ $t('content.actpawn2') }}</option>
                      <option value="REDEEM">{{ $t('content.actpawn5') }}</option>
                      <option value="DEC_PRINCIPLE">{{ $t('content.actpawn4') }}</option>
                      <option value="INC_PRINCIPLE">{{ $t('content.actpawn3') }}</option>
                      <option value="PAYMENT">{{ $t('content.actpawn7') }}</option>
                      <option value="REVIEW_COLLATERAL">{{ $t('content.actpawn6') }}</option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input v-model="tk_searcht" id="ticketno" type="text"
                      :disabled="search_groupt === '' || search_shopt === ''" />
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.jobId") }}</label>
                    <material-input v-model="jb_searcht" id="jobno" type="text"
                      :disabled="search_groupt === '' || search_shopt === ''" />
                  </div>

                </div>
                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="getqueuelist"
                        :disabled="search_groupt === '' || search_shopt === '' || queue_searcht === '' || ty_searcht === ''">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ $t('buttons.sear') }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelTBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ $t('buttons.canc') }}
                      </material-button>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.jobId") }}</th>
                          <th>{{ $t("content.trayId") }}</th>
                          <th>{{ $t("content.amndatetime") }}</th>
                          <th>{{ $t("content.tkOwner") }}</th>
                          <th>{{ $t("content.oldname") }}</th>
                          <th>{{ $t("content.refnumber") }}</th>
                          <th>{{ $t("content.payside") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.amnweightvalall") }}</th>
                          <th>{{ $t("content.amnqtyunitall") }}</th>
                          <th>{{ $t("content.amnanalysval") }}</th>
                          <th>{{ $t("content.amnmaxvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.amnlastmaker") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody data-group-index="0">
                        <tr v-for="(row, index) in listq" :key="index" :class="row.paySide == 'PAY' && row.migration ? 'bg-redeem'
                          : row.paySide == 'PAY' && !row.migration ? 'bg-payment'
                            : row.paySide === 'RECEIVE' && row.migration ? 'bg-reduce-cap'
                              : row.paySide === 'RECEIVE' && !row.migration ? 'bg-receive'
                                : row.paySide === 'NONE' && row.migration ? 'bg-nonemi' : 'bg-none'">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString(index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ row.jobId }}</td>
                          <td class="text-sm font-weight-normal">{{ row.trayId }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.startTime) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ checkPaySide(row.paySide) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="!row.migration">
                              {{ checkTransaction(row.type) }}
                            </span>
                            <span v-else>
                              {{ checkTransaction(row.migrationType) }} ({{ checkTransaction(row.migrationType) }})
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.newPawnValue) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.fullValue) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.migration">
                              <span
                                v-if="row.migrationType === 'PAWN' || row.migrationType === 'INC_PRINCIPLE' && row.totalPay > 0">
                                {{ formatNumberDecimalString(row.totalPay) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.totalReceive) }}
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.type === 'PAWN' || row.type === 'INC_PRINCIPLE' && row.totalPay > 0">
                                {{ formatNumberDecimalString(row.totalPay) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.totalReceive) }}
                              </span>
                            </span>
                          </td>
                          <td class=" text-sm font-weight-normal">{{ row.latestUserName }}
                          </td>

                          <td class="text-sm font-weight-normal">
                            <material-button color="warning" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.amnunlock')"
                              @click="onUnLockDialog(row)" :disabled="row.status !== 'LOCK'">
                              <i class="material-icons material-symbols-outlined">lock_open</i>
                            </material-button>
                            <material-button color="success" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" title="Complete"
                              @click="completeItems(row)" :disabled="row.status === 'LOCK'">
                              <i class=" material-icons material-symbols-outlined">check</i>
                            </material-button>
                            <material-button color="danger" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" title="Terminate"
                              @click="terminateItems(row)" :disabled="row.status === 'LOCK'">
                              <i class="material-icons material-symbols-outlined">close</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.amnticketmanage')"
                              @click="editWorckcaseItems(row)" :disabled="ty_searcht === 'PAYMENT'">
                              <i class=" material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <button id="workcaseModal" class="btn btn-primary" type="button" data-bs-toggle="modal"
                              data-bs-target="#updateWorkcaseModal" v-show="false">
                            </button>
                            <material-button color="secondary" variant="outline" class="rounded-circle" title="ดู Info"
                              @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">data_object</i>
                            </material-button>
                            <material-button variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#workcaseInfoModal" id="workcaseInfo">
                            </material-button>

                          </td>
                        </tr>
                        <tr v-if="listq.length === 0">
                          <td colspan="9"></td>
                          <td class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="18" style="text-align: right">Total Rows : {{ totalRows_sQ }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listq.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageQ" :total-items="totalRowsQ"
                          :items-per-page="perPageQ" @click="onClickHandlerQ" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.meditpg") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mgroup") }}</label>
                    <select class="form-select" v-model="search_groupp" @change="shoplist_p">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listgroup" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mshoup") }}</label>
                    <select class="form-select" v-model="search_shopp" :disabled="search_groupp === ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listshop_p" :key="opt1" :value="a.uid">
                        {{ a.nameTh }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.queue") }}</label>
                    <select class="form-select" v-model="queue_searchp"
                      :disabled="search_groupp === '' || search_shopp === ''">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option value="Q01">Q01</option>
                      <option value="Q02">Q02</option>
                      <option value="Q03">Q03</option>
                      <option value="Q04">Q04</option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.trans") }}</label>
                    <select class="form-select" v-model="ty_searchp"
                      :disabled="search_groupp === '' || search_shopp === ''">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option value="PAWN">{{ $t('content.actpawn1') }}</option>
                      <option value="INTEREST">{{ $t('content.actpawn2') }}</option>
                      <option value="REDEEM">{{ $t('content.actpawn5') }}</option>
                      <option value="DEC_PRINCIPLE">{{ $t('content.actpawn4') }}</option>
                      <option value="INC_PRINCIPLE">{{ $t('content.actpawn3') }}</option>
                      <option value="PAYMENT">{{ $t('content.actpawn7') }}</option>
                      <option value="REVIEW_COLLATERAL">{{ $t('content.actpawn6') }}</option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input v-model="tk_searchp" id="ticketno" type="text"
                      :disabled="search_groupp === '' || search_shopp === ''" />
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="getpaylist"
                        :disabled="search_groupp === '' || search_shopp === '' || queue_searchp === '' || ty_searchp === ''">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ $t('buttons.sear') }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelPBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ $t('buttons.canc') }}
                      </material-button>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.jobId") }}</th>
                          <th>{{ $t("content.trayId") }}</th>
                          <th>{{ $t("content.amndatetime") }}</th>
                          <th>{{ $t("content.tkOwner") }}</th>
                          <th>{{ $t("content.oldname") }}</th>
                          <th>{{ $t("content.refnumber") }}</th>
                          <th>{{ $t("content.payside") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.amnweightvalall") }}</th>
                          <th>{{ $t("content.amnqtyunitall") }}</th>
                          <th>{{ $t("content.amnanalysval") }}</th>
                          <th>{{ $t("content.amnmaxvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.amnlastmaker") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody data-group-index="0">
                        <tr v-for="(row, index) in listp" :key="index" :class="row.paySide == 'PAY' && row.migration ? 'bg-redeem'
                          : row.paySide == 'PAY' && !row.migration ? 'bg-payment'
                            : row.paySide === 'RECEIVE' && row.migration ? 'bg-reduce-cap'
                              : row.paySide === 'RECEIVE' && !row.migration ? 'bg-receive'
                                : row.paySide === 'NONE' && row.migration ? 'bg-nonemi' : 'bg-none'">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString(index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ row.jobId }}</td>
                          <td class="text-sm font-weight-normal">{{ row.trayId }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.startTime) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ checkPaySide(row.paySide) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="!row.migration">
                              {{ checkTransaction(row.type) }}
                            </span>
                            <span v-else>
                              {{ checkTransaction(row.migrationType) }} ({{ checkTransaction(row.migrationType) }})
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.newPawnValue) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.fullValue) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.migration">
                              <span
                                v-if="row.migrationType === 'PAWN' || row.migrationType === 'INC_PRINCIPLE' && row.totalPay > 0">
                                {{ formatNumberDecimalString(row.totalPay) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.totalReceive) }}
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.type === 'PAWN' || row.type === 'INC_PRINCIPLE' && row.totalPay > 0">
                                {{ formatNumberDecimalString(row.totalPay) }}
                              </span>
                              <span v-else>
                                {{ formatNumberDecimalString(row.totalReceive) }}
                              </span>
                            </span>
                          </td>
                          <td class=" text-sm font-weight-normal">{{ row.latestUserName }}
                          </td>

                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" @click="editRowItems(row)">
                              <i class=" material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <button id="updateModal" class="btn btn-primary" type="button" data-bs-toggle="modal"
                              data-bs-target="#updatePaymentModal" v-show="false">
                            </button>
                          </td>
                        </tr>
                        <tr v-if="listp.length === 0">
                          <td colspan="9"></td>
                          <td class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="18" style="text-align: right">Total Rows : {{ totalRows_sP }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listp.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageP" :total-items="totalRowsP"
                          :items-per-page="perPageP" @click="onClickHandlerP" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <div id="tab3" class="tab-pane fade" role="tabpanel" aria-labelledby="tab3-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.editimg") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mgroup") }}</label>
                    <select class="form-select" v-model="search_groupi" @change="shoplist_i">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listgroup" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mshoup") }}</label>
                    <select class="form-select" v-model="search_shopi" :disabled="search_groupi === ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listshop_i" :key="opt1" :value="a.uid">
                        {{ a.nameTh }}
                      </option>
                    </select>
                  </div>


                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input v-model="tk_searchi" id="ticketno" type="text"
                      :disabled="search_groupi === '' || search_shopi === ''" />
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="getHistoryByRefnumber"
                        :disabled="search_groupi === '' || search_shopi === '' || tk_searchi === ''">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ $t('buttons.sear') }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelIBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ $t('buttons.canc') }}
                      </material-button>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.amnticketold") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.stockno") }}</th>
                          <th>{{ $t("content.migraref") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.allweight") }}</th>
                          <th>{{ $t("content.allqty") }}</th>
                          <th>{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>
                            {{ $t("content.actpawn3") }} /
                            {{ $t("content.actpawn4") }}
                          </th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.assessor") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhistory" :key="index"
                          :class="row.status !== 'TERMINATE' ? '' : 'bg-working'">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage - 1) * perPage +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.cusName }}
                            </span>
                            <span v-else>
                              {{ row.tkCusName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.stockNumber }}</td>
                          <td class="text-sm font-weight-normal text-center">{{ row.migrateRefNumber }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.represent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ทำแทน)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ทำแทน)
                              </span>
                            </span>
                            <span v-else-if="row.shopRepresent">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }},ออนไลน์)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (ออนไลน์)
                              </span>
                            </span>
                            <span v-else-if="row.changeName">
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType)
                                }},เปลี่ยนชื่อ)
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                              </span>
                            </span>
                            <span v-else>
                              <span v-if="row.migration">
                                {{ checkTransaction(row.type) }} ({{ checkTransaction(row.migrationType) }})
                              </span>
                              <span v-else>
                                {{ checkTransaction(row.type) }}
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.roundInterest) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.diffValue) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberDecimalString(row.payOrReceive) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.managerName }}</td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ checkProcess(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.editimg')"
                              @click="openGallery(row)">
                              <i class=" material-icons material-symbols-outlined">photo_library</i>
                            </material-button>
                            <material-button data-bs-toggle="modal" data-bs-target="#attachmentsModal" v-show="false"
                              id="attachmenDialog">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listhistory.length === 0">
                          <td colspan="16" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="group-sub-header" style="background-color: white;">
                          <td class="text-lg font-weight-bold text-end text-center" colspan="8">
                            <span v-if="listhistory.length > 0">
                              <b>{{ $t("content.gtotal") }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalWeight) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberString(totalQuantity) }}</b>
                            </span>
                          </td>

                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold">
                            <span v-if="listhistory.length > 0">
                              <b>{{ formatNumberDecimalString(totalInterest) }}</b>
                            </span>
                          </td>
                          <td class="text-lg font-weight-bold" colspan="4"></td>
                          <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <div id="tab4" class="tab-pane fade" role="tabpanel" aria-labelledby="tab4-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>Lunch Q</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mgroup") }}</label>
                    <select class="form-select" v-model="search_groupl" @change="shoplist_l">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listgroup" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mshoup") }}</label>
                    <select class="form-select" v-model="search_shopl" :disabled="search_groupl === ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listshop_l" :key="opt1" :value="a.uid">
                        {{ a.nameTh }}
                      </option>
                    </select>
                  </div>

                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="getlaunchQList"
                        :disabled="search_groupl === '' || search_shopl === ''">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ $t('buttons.sear') }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelLBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ $t('buttons.canc') }}
                      </material-button>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.amnchannel") }}</th>
                          <th>Exception</th>
                          <th>Queue Info</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listlunch_q" :key="index">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage_l - 1) * perPage_l +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.channel === 'SHOP'">
                              {{ $t("content.gchshop") }}
                            </span>
                            <span v-else>
                              LINE OA
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button v-if="row.exception !== null" color="secondary" variant="outline" class="rounded-circle" title="ดู Exception"
                              @click="openException(row)">
                              <i class="material-icons material-symbols-outlined">data_object</i>
                            </material-button>
                            <material-button variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#exceptionInfoModal" id="exceptionInfo">
                            </material-button>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button  color="info" variant="outline" class="rounded-circle" title="ดู Queue Info"
                              @click="getQueueInfo(row)">
                              <i class="material-icons material-symbols-outlined">search</i>
                            </material-button>
                            <material-button variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#pgInfoModal" id="pgInfo">
                            </material-button>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="danger" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" title="Delete"
                              @click="deleteLunchItems(row)">
                              <i class="material-icons material-symbols-outlined">close</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listlunch_q.length === 0">
                          <td colspan="16" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="group-sub-header" style="background-color: white;">
                          <td class="text-lg font-weight-bold" colspan="5"></td>
                          <td style="text-align: right">Total Rows : {{ totalRows_sl }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listlunch_q.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage_l" :total-items="totalRows_l" :items-per-page="perPage_l"
                          @click="onClickHandlerL" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <div id="tab5" class="tab-pane fade" role="tabpanel" aria-labelledby="tab5-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>Re Lunch Q</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mgroup") }}</label>
                    <select class="form-select" v-model="search_groupr" @change="shoplist_r">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listgroup" :key="opt1" :value="a.uid">
                        {{ a.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.mshoup") }}</label>
                    <select class="form-select" v-model="search_shopr" :disabled="search_groupr === ''">
                      <option value="" selected disabled>{{ $t("content.select") }}</option>
                      <option v-for="(a, opt1) in listshop_r" :key="opt1" :value="a.uid">
                        {{ a.nameTh }}
                      </option>
                    </select>
                  </div>

                </div>

                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="getrelaunchList"
                        :disabled="search_groupr === '' || search_shopr=== ''">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ $t('buttons.sear') }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelRBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ $t('buttons.canc') }}
                      </material-button>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.dant") }}</th>
                          <th>{{ $t("content.amnchannel") }}</th>
                          <th>Exception</th>
                          <th>Queue Info</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listrelunch_q" :key="index">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage_r - 1) * perPage_r +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.channel === 'SHOP'">
                              {{ $t("content.gchshop") }}
                            </span>
                            <span v-else>
                              LINE OA
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button v-if="row.exception !== null" color="secondary" variant="outline" class="rounded-circle" title="ดู Exception"
                              @click="openException(row)">
                              <i class="material-icons material-symbols-outlined">data_object</i>
                            </material-button>
                            <material-button variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#exceptionInfoModal" id="exceptionInfo">
                            </material-button>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button  color="info" variant="outline" class="rounded-circle" title="ดู Queue Info"
                              @click="getQueueFInfo(row)">
                              <i class="material-icons material-symbols-outlined">search</i>
                            </material-button>
                            <material-button variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#pgInfoModal" id="pgInfo">
                            </material-button>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="success" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" title="ReLunch"
                              @click="reLunchItems(row)" >
                              <i class=" material-icons material-symbols-outlined">restart_alt</i>
                            </material-button>
                            
                          </td>
                        </tr>
                        <tr v-if="listrelunch_q.length === 0">
                          <td colspan="16" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr class="group-sub-header" style="background-color: white;">
                          <td class="text-lg font-weight-bold" colspan="5"></td>
                          <td style="text-align: right">Total Rows : {{ totalRows_sr }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listrelunch_q.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage_r" :total-items="totalRows_r" :items-per-page="perPage_r"
                          @click="onClickHandlerR" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>



          <!-- Update Payment Dialog -->
          <div id="updatePaymentModal" class="modal fade" tabindex="-1" aria-labelledby="updatePaymentModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">
                    {{ $t("content.amnfinanceinfo") }}
                  </h4>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeAfModal">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body" v-if="paymentE !== null">
                  <div class="preview-table">
                    <section class="panel">
                      <div class="table-responsive">
                        <table class="table table-flush table-hover">
                          <thead class="thead-light">
                            <tr>
                              <th>{{ $t("content.cname") }}</th>
                              <th>{{ $t("content.ticketno") }}</th>
                              <th>{{ $t("content.amnbiz") }}</th>
                              <th>{{ $t("content.amnfinanceoutput") }}</th>
                              <th>{{ $t("content.amnfinanceinput") }}</th>
                              <th>{{ $t("content.status") }}</th>
                            </tr>
                          </thead>
                          <tbody>

                            <tr v-for="(row, index) in listpaymentD" :key="index"
                              :class="row.status != 'TERMINATE' ? '' : 'bg-working'">
                              <template v-if="row.type !== 'PAYMENT'">
                                <td class="text-sm font-weight-normal">{{ row.customerName }}</td>
                                <td class="text-sm font-weight-normal">{{ row.initRefNumber }}</td>
                                <td class="text-sm font-weight-normal">{{ checkTransaction(row.type) }}</td>
                                <td class="text-sm font-weight-normal">
                                  <span v-if="row.totalPay !== 0" style="color:red;">
                                    {{ formatNumberString(row.totalPay) }}
                                  </span>
                                </td>
                                <td class="text-sm font-weight-normal">
                                  <span v-if="row.totalReceive !== 0" style="color:green;">
                                    {{ formatNumberString(row.totalReceive) }}
                                  </span>
                                </td>
                                <td class="text-sm font-weight-normal"> {{ checkProcess(row.status) }}</td>
                              </template>
                            </tr>
                          </tbody>
                          <tfoot class="table-light">
                            <tr>
                              <td class="text-sm font-weight-bold" colspan="3">
                                {{ $t("content.amntotaltransact") }}
                              </td>
                              <td class="text-sm font-weight-bold">{{ formatNumberString(paymentE.roundTotalPay) }}
                              </td>
                              <td class="text-sm font-weight-bold">{{ formatNumberString(paymentE.roundTotalReceive) }}
                              </td>
                              <td class="text-sm font-weight-bold">
                                <span v-if="paymentE.roundTotalPay !== 0" style="color:red;">
                                  {{ $t("content.amnpay") }}
                                </span>
                                <span v-if="paymentE.roundTotalReceive !== 0" style="color:green;">
                                  {{ $t("content.amnget") }}
                                </span>
                              </td>
                            </tr>
                          </tfoot>

                        </table>
                      </div>
                      <div class="row mt-2">
                        <div class="col-auto mt-3">
                          <h6 :class="showPaid ? `text-success` : ``">
                            {{
                              showPaid
                                ? $t("content.amnpaycompleted")
                                : $t("content.amnfinanceprocess")
                            }}
                          </h6>
                        </div>
                        <div class="col-auto">
                          <InputNumber v-model="paytt" :minFractionDigits="0" :maxFractionDigits="2" autocomplete="off"
                            @focus="$event.target.select()" fluid />
                        </div>

                      </div>
                    </section>
                  </div>
                </div>

                <div class="modal-footer" v-if="paymentE !== null">
                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                    :disabled="paytt === null || paytt === 0" @click="updatePaymentGroup">
                    {{ $t("buttons.conf") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- updateWorkcase Modal -->
          <div class="modal fade" id="updateWorkcaseModal" tabindex="-1" aria-labelledby="updateWorkcaseModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="updateWorkcaseModalLabel">
                    {{ $t("content.amnsplitlist") }}
                  </h1>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>
                <div class="modal-body">
                  <span v-if="listcoll.length !== 0">
                    <div class="table-responsive">
                      <table class="table table-sm table-hover">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>{{ $t("content.amnassetgroup") }}</th>
                            <th>pawnValue</th>
                            <th>newPawnValue</th>
                            <th>tmpPawnValue</th>
                            <th>tmpNewPawnValue</th>
                            <th>{{ $t("content.act") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in listcoll" :key="index">
                            <td class="text-sm font-weight-normal">{{ formatNumberString(index + 1) }}</td>
                            <td class="text-sm font-weight-normal">{{ filterCat(row.mainCatUid) }}</td>
                            <td class="text-sm font-weight-normal">
                              <InputNumber v-model="row.pawnValue" :minFractionDigits="0" :maxFractionDigits="2"
                                autocomplete="off" @focus="$event.target.select()" fluid />
                            </td>
                            <td class="text-sm font-weight-normal">
                              <InputNumber v-model="row.newPawnValue" :minFractionDigits="0" :maxFractionDigits="2"
                                autocomplete="off" @focus="$event.target.select()" fluid />
                            </td>
                            <td class="text-sm font-weight-normal">
                              <InputNumber v-model="row.tmpPawnValue" :minFractionDigits="0" :maxFractionDigits="2"
                                autocomplete="off" @focus="$event.target.select()" fluid />
                            </td>
                            <td class="text-sm font-weight-normal">
                              <InputNumber v-model="row.tmpNewPawnValue" :minFractionDigits="0" :maxFractionDigits="2"
                                autocomplete="off" @focus="$event.target.select()" fluid />
                            </td>
                            <td class="text-sm font-weight-normal">
                              <material-button color="secondary" variant="outline" class="rounded-circle"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.save')"
                                :disabled="(row.pawnValue === null || row.pawnValue === '') || (row.newPawnValue === null || row.newPawnValue === '')
                                  || (row.tmpPawnValue === null || row.tmpPawnValue === '') || (row.tmpNewPawnValue === null || row.tmpNewpawnValue === '')" @click="updateCollateral(row)">
                                <i class="material-icons material-symbols-outlined">save</i>
                              </material-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Delete File Dialog -->
          <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="unseizeModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 700px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ $t("content.insertimg") }} : {{ images.length }}
                  </h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeattach">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <pre></pre>
                    <div class="grid-containerP" v-if="images.length">
                      <div v-for="item, index in images" :key="index" class="d-inline-block mx-2">
                        <td>
                          <div class="wrapper">
                            <figure width="100px" height="100px">
                              <img :src="item.src" class="img img-fluid" />
                            </figure>
                            <button type="button" class="btn myLayer" style="color: red;" :title="t('buttons.dele')"
                              @click="removeImage(item, index)">
                              <i i class="material-icons">close</i>
                            </button>
                          </div>
                        </td>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>


          <!-- Workcase Info Dialog -->
          <div id="workcaseInfoModal" class="modal fade" tabindex="-1" aria-labelledby="workcaseInfoModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1000px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Workcase Info
                  </h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeWorkcaseInfo">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <pre>{{ JSON.stringify(workcaseInfo, null, 2) }}</pre>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>


          <!-- Exception Info Dialog -->
          <div id="exceptionInfoModal" class="modal fade" tabindex="-1" aria-labelledby="ExceptionInfoModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Exception Info
                  </h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeExceptionInfo">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <pre>{{ exceptionInfo }}</pre>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>


          <!-- Queue Info Dialog -->
          <div id="pgInfoModal" class="modal fade" tabindex="-1" aria-labelledby="pgInfoModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1000px">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    Queue Info
                  </h5>
                  <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closePgInfo">
                    <i class="material-icons material-symbols-outlined">close</i>
                  </button>
                </div>

                <div class="modal-body">
                  <fieldset>
                    <pre>{{ JSON.parse(queueInfo, null, 2) }}</pre>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>





        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { inject, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import InputNumber from 'primevue/inputnumber';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import moment from 'moment'
import ExampleFive from "@/examples/ExampleOne";
import ProgressSpinner from 'primevue/progressspinner';
import nofinger from "@/assets/img/noimg.png"
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import * as st from "@/config/setting.js";
import axios from "axios";

import { useShopStore } from "@/stores/shop";
import { useGroupStore } from "@/stores/group";
import { useworkItemStore } from "@/stores/workitem";
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useCollateralStore } from '@/stores/collateral'
import { useWorkCaseStore } from '@/stores/workcase'
import { useCategoryStore } from '@/stores/category'
import { useDocumentStore } from '@/stores/document'

const { t } = useI18n();
const swal = inject("$swal");


const storesh = useShopStore()
const storegr = useGroupStore()
const storewt = useworkItemStore()
const storep = usePaymentGroupStore()
const storec = useCollateralStore()
const storew = useWorkCaseStore()
const storecat = useCategoryStore()
const storedoc = useDocumentStore()

const listgroup = ref([]);
const listshop_t = ref([]);
const listshop_p = ref([]);
const listshop_i = ref([]);
const listshop_l = ref([]);
const listshop_r = ref([]);

const search_groupt = ref("");
const search_groupp = ref("");
const search_groupr = ref("");
const search_groupl = ref("");
const search_shopt = ref("");
const search_shopp = ref("");
const search_shopr = ref("");
const search_shopl = ref("");
const queue_searcht = ref('');
const queue_searchp = ref('');
const tk_searcht = ref('');
const tk_searchp = ref('');
const jb_searcht = ref('');
const jb_searchp = ref('');
const ty_searcht = ref('');
const ty_searchp = ref('');

const search_groupi = ref("");
const search_shopi = ref("");
const tk_searchi = ref('');

const listq = ref([]);
const listp = ref([]);
const listhistory = ref([]);
const listlunch_q = ref([]);
const listrelunch_q = ref([]);

const currentPageQ = ref(1);
const totalRowsQ = ref(1);
const perPageQ = ref(10);
const totalRows_sQ = ref('');

const currentPageP = ref(1);
const totalRowsP = ref(1);
const perPageP = ref(10);
const totalRows_sP = ref('');

const paymentE = ref({});
const listpaymentD = ref({});
const paytt = ref(0);

const listprint = ref([]);
const listcoll = ref([]);

const workcaseInfo = ref(null);
const workcaseDetail_u = ref(null);
const workcaseDetail_i = ref(null);
const images = ref([])
const images_l = ref([])
const loading_d = ref(false);

const showPaid = ref(false);

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();


const totalQuantity = ref(0);
const totalPawnValue = ref(0);
const totalWeight = ref(0);
const totalInterest = ref(0);

const versionColl = ref('');

const currentPage_l = ref(1);
const totalRows_l = ref(1);
const perPage_l = ref(30);
const totalRows_sl = ref();

const currentPage_r = ref(1);
const totalRows_r = ref(1);
const perPage_r = ref(30);
const totalRows_sr = ref();

const exceptionInfo = ref(null);
const queueInfo = ref(null);


const onClickHandlerQ = (page) => {
  updatePaginationQ()
};

const onClickHandlerP = (page) => {
  updatePaginationP()
};


const onClickHandler = (page) => {
  updatePagination()
};

const onClickHandlerL = (page) => {
  updatePaginationL()
};


const onClickHandlerR = (page) => {
  updatePaginationR()
};

const loadgroupListApi = async (val) => {
  listgroup.value = [];
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
  };
  const payload = data;
  // console.log("loadgroupListApi p : " + JSON.stringify(payload));
  const response = await storegr.groupListFetch(payload);
  // console.log("loadgroupListApi r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listgroup.value = response.data.data.list;
      }
    }
  }
}

loadgroupListApi();

const loadDataPrintApi = async () => {
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  const response = await storecat.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
      }
    }
  }
}

loadDataPrintApi();

async function shoplist() {
  listshop_t.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: search_groupt.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listshop_t.value = response.data.data.list;
      }
    }
  }
}

async function shoplist_p() {
  listshop_p.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: search_groupp.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listshop_p.value = response.data.data.list;
      }
    }
  }
}


async function shoplist_i() {
  listshop_i.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: search_groupi.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listshop_i.value = response.data.data.list;
      }
    }
  }
}


async function shoplist_l() {
  listshop_l.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: search_groupl.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listshop_l.value = response.data.data.list;
      }
    }
  }
}


async function shoplist_r() {
  listshop_r.value = [];
  let data = "";
  data = {
    index: "0",
    size: 100,
    nameTh: "",
    nameEn: "",
    guid: search_groupr.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storesh.shopListFetch(payload);
  // console.log('loadDataApi : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listshop_r.value = response.data.data.list;
      }
    }
  }
}



async function getqueuelist() {
  listq.value = [];
  currentPageQ.value = 1;
  let data = "";
  data = {
    index: currentPageQ.value - 1,
    size: perPageQ.value,
    name: "",
    shopUid: search_shopt.value,
    queueCode: queue_searcht.value, // Q01, Q02, Q03, Q04
    tkRefNumber: tk_searcht.value.trim(),
    jobId: jb_searcht.value,
    type: ty_searcht.value,
  };
  const payload = data;
  // console.log('queuel p : ' + JSON.stringify(payload));
  const response = await storewt.platformListFetch(payload);
  // console.log('queuel r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listq.value = response.data.data.list;
        totalRowsQ.value = response.data.data.ext.total
        totalRows_sQ.value = formatNumberString(totalRowsQ.value)
      }
    }
  }
}

async function updatePaginationQ() {
  listq.value = []
  let data = "";
  data = {
    index: currentPageQ.value - 1,
    size: perPageQ.value,
    name: "",
    shopUid: search_shopt.value,
    queueCode: queue_searcht.value, // Q01, Q02, Q03, Q04
    tkRefNumber: tk_searcht.value.trim(),
    jobId: jb_searcht.value,
    type: ty_searcht.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storewt.platformListFetch(payload);
  // console.log('queuel : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listq.value = response.data.data.list;
        totalRowsQ.value = response.data.data.ext.total
        totalRows_sQ.value = formatNumberString(totalRowsQ.value)
      }
    }
  }
}

async function getpaylist() {
  listp.value = [];
  currentPageP.value = 1;
  let data = "";
  data = {
    index: currentPageP.value - 1,
    size: perPageP.value,
    name: "",
    shopUid: search_shopp.value,
    queueCode: queue_searchp.value, // Q01, Q02, Q03, Q04
    tkRefNumber: tk_searchp.value.trim(),
    jobId: '',
    type: ty_searchp.value,
  };
  const payload = data;
  // console.log('payl p : ' + JSON.stringify(payload));
  const response = await storewt.platformListFetch(payload);
  // console.log('payl r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listp.value = response.data.data.list;
        totalRowsP.value = response.data.data.ext.total
        totalRows_sP.value = formatNumberString(totalRowsP.value)
      }
    }
  }
}

async function updatePaginationP() {
  listp.value = [];
  let data = "";
  data = {
    index: currentPageP.value - 1,
    size: perPageP.value,
    name: "",
    shopUid: search_shopp.value,
    queueCode: queue_searchp.value, // Q01, Q02, Q03, Q04
    tkRefNumber: tk_searchp.value,
    jobId: '',
    type: ty_searchp.value,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storewt.platformListFetch(payload);
  // console.log('payl : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listp.value = response.data.data.list;
        totalRowsP.value = response.data.data.ext.total
        totalRows_sP.value = formatNumberString(totalRowsP.value)
      }
    }
  }
}


function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined && num !== '') {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm')
  }
}

function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}


async function onClickTab(val) {
  if (val === '1') {
    await setfirstTab()
  } else if (val === '2') {
    await setsecondTab()
  } else if (val === '3') {
    await setthirddTab()
  }else if (val === '4') {
    await setfourthTab()
  }else if (val === '5') {
    await setfifthTab()
  }
}


async function cancelTBtn() {
  search_groupt.value = ''
  search_shopt.value = ''
  queue_searcht.value = ''
  tk_searcht.value = ''
  jb_searcht.value = ''
  ty_searcht.value = ''
  currentPageQ.value = 1
  totalRows_sQ.value = ''
  listq.value = []
  workcaseDetail_u.value = null
  images.value = []
  images_l.value = []
  loading_d.value = false
  listcoll.value = []
  versionColl.value = ''
}

async function cancelPBtn() {
  search_groupp.value = ''
  search_shopp.value = ''
  queue_searchp.value = ''
  tk_searchp.value = ''
  jb_searchp.value = ''
  ty_searchp.value = ''
  currentPageP.value = 1
  totalRows_sP.value = ''
  listp.value = []
}


async function cancelIBtn() {
  search_groupi.value = ''
  search_shopi.value = ''
  tk_searchi.value = ''
  listhistory.value = []
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  totalRows_s.value = ''
  currentPage.value = 1
  workcaseDetail_i.value = null
}


async function cancelLBtn() { 
  search_groupl.value = ''
  search_shopl.value = ''
  listlunch_q.value = []
  currentPage_l.value = 1
  totalRows_sl.value = ''
}


async function cancelRBtn() { 
  search_groupr.value = ''
  search_shopr.value = ''
  listrelunch_q.value = []
  currentPage_r.value = 1
  totalRows_sr.value = ''
}

function checkPaySide(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAY') {
    side = 'จ่ายเงิน'
  } else if (str === 'RECEIVE') {
    side = 'รับเงิน'
  } else if (str === 'NONE') {
    side = 'ไม่มียอด'
  }
  return side
}


function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  } else if (str === 'REVIEW_COLLATERAL') {
    side = 'ขอดูทรัพย์'
  } else if (str === 'PAYMENT') {
    side = 'การชำระ'
  }
  return side
}

function checkProcess(str) {
  let side = ''
  if (str === 'FINISH') {
    side = 'เสร็จสิ้น'
  } else if (str === 'ACTIVE') {
    side = 'กำลังดำเนินการ'
  } else if (str === 'FREEZE') {
    side = 'อายัด'
  } else if (str === 'TERMINATE') {
    side = 'ยกเลิก'
  } else if (str === 'BREAKING') {
    side = 'ของหลุด'
  }
  return side
}


async function onUnLockDialog(item) {
  swal({
    title: "ปลดล็อกรายการ",
    text: "คุณต้องการปลดล็อกรายการนี้",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      onUnLockStep(item)
    }
  });
}

async function completeItems(item) {
  swal({
    title: "ต้องการ Complete Step รายการนี้",
    text: "คุณต้องการ Complete รายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.save'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        completeStep(item)
      }
    }
  })
}


async function terminateItems(item) {
  swal({
    title: "ต้องการ Terminate รายการนี้",
    text: "คุณต้องการ Terminate รายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.save'),
    cancelButtonText: t('buttons.canc'),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        terminateStep(item)
      }
    }
  })
}


async function editRowItems(item) {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        detailPayment(item)
      }
    }
  });
}


async function editWorckcaseItems(item) {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.workCaseUid !== "") {
        getWorkCaseUpdateInfo(item)
      }
    }
  });
}


async function onUnLockStep(item) {
  let data = "";
  let lockL = []
  lockL.push({ uid: item.uid, version: item.version })
  data = {
    groupUid: search_groupt.value, // for platform
    shopUid: search_shopt.value, // for platform
    workItems: lockL,
  };
  const payload = data;
  // console.log('unl p : ' + JSON.stringify(payload));
  const response = await storewt.platformUnlockFetch(payload);
  // console.log('unl r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await getqueuelist()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function completeStep(item) {
  let data = "";
  data = {
    groupUid: search_groupt.value, // for platform
    shopUid: search_shopt.value, // for platform
    uid: item.uid, // workItem uid
    action: 'complete', // action name
    version: item.version,
  };
  const payload = data;
  // console.log('complete p : ' + JSON.stringify(payload));
  const response = await storewt.platformCompleteStepFetch(payload);
  // console.log('complete r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await getqueuelist()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function terminateStep(item) {
  let data = "";
  let lockL = []
  lockL.push({ uid: item.uid, version: item.version })
  data = {
    groupUid: search_groupt.value, // for platform
    shopUid: search_shopt.value, // for platform
    workItems: lockL,
  };
  const payload = data;
  // console.log('ter p : ' + JSON.stringify(payload));
  const response = await storewt.platformTerminateFetch(payload);
  // console.log('ter r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await getqueuelist()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function detailPayment(item) {
  paytt.value = 0
  paymentE.value = null
  let list = []
  listpaymentD.value = []
  let data = "";
  data = {
    groupUid: search_groupp.value,
    shopUid: search_shopp.value,
    uid: item.paymentGroupUid,
  };
  const payload = data;
  // console.log('deP p : ' + JSON.stringify(payload));
  const response = await storep.paymentGroupInfoAdminFetch(payload);
  // console.log('detailPayment r : ' + JSON.stringify(response.data.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        list = paymentE.value.workCases
        for (let i = 0; i < list.length; i++) {
          listpaymentD.value.push(...list[i].workItems)
        }
        if (paymentE.value.roundTotalPay !== null && paymentE.value.roundTotalPay !== 0) {
          paytt.value = paymentE.value.roundTotalPay
        } else if (paymentE.value.roundTotalReceive !== null && paymentE.value.roundTotalReceive !== 0) {
          paytt.value = paymentE.value.roundTotalReceive
        }
        // console.log('listpaymentD : ' + JSON.stringify(listpaymentD.value));
        document.getElementById("updateModal").click();
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}

async function updatePaymentGroup() {
  let data = "";
  let ttrecive = 0
  let ttpay = 0
  if (paymentE.value.roundTotalPay !== null && paymentE.value.roundTotalPay !== 0) {
    ttrecive = paymentE.value.roundTotalReceive
    ttpay = paytt.value
  } else if (paymentE.value.roundTotalReceive !== null && paymentE.value.roundTotalReceive !== 0) {
    ttrecive = paytt.value
    ttpay = paymentE.value.roundTotalPay
  }

  data = {
    groupUid: search_groupp.value,
    shopUid: search_shopp.value,
    uid: paymentE.value.uid,
    paySide: paymentE.value.paySide, // PAY, RECEIVE, NONE
    totalPay: paymentE.value.totalPay,
    roundTotalPay: ttpay,
    totalReceive: paymentE.value.totalReceive,
    roundTotalReceive: ttrecive,
    totalFeeReceive: paymentE.value.totalFeeReceive,
    totalFeePay: paymentE.value.totalFeePay,
    remark: paymentE.value.remark,
    version: paymentE.value.version,
  };
  const payload = data;
  // console.log('updateP p : ' + JSON.stringify(payload));
  const response = await storep.platformPaymentGroupupdateFetch(payload);
  // console.log('updateP r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await getpaylist()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function getWorkCaseUpdateInfo(item) {
  workcaseDetail_u.value = null
  listcoll.value = []
  let data = "";
  data = {
    groupUid: search_groupt.value,
    shopUid: search_shopt.value,
    uid: item.workCaseUid,
  };
  const payload = data;
  // console.log('wc p : ' + JSON.stringify(payload));
  const response = await storew.workCaseinfoAdminFetch(payload);
  // console.log('wc r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail_u.value = response.data.data
        listcoll.value = response.data.data.ticket.collaterals
        if (listcoll.value.length > 0) {
          // console.log('listcoll : ' + JSON.stringify(listcoll.value));
          document.getElementById("workcaseModal").click();
        } else {
          swal('Record not found', "", "error");
        }
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function getWorkCaseImgInfo(item) {
  workcaseDetail_i.value = null
  images_l.value = []
  images.value = []

  let data = "";
  data = {
    groupUid: search_groupi.value,
    shopUid: search_shopi.value,
    uid: item.uid,
  };
  const payload = data;
  // console.log('wc p : ' + JSON.stringify(payload));
  const response = await storew.workCaseinfoAdminFetch(payload);
  // console.log('wc r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail_i.value = response.data.data
        images_l.value = workcaseDetail_i.value.ticket.images
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function openGallery(item) {
  await getWorkCaseImgInfo(item)
  if (images_l.value.length > 0) {
    loading_d.value = true
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        await getFileImg(images_l.value[i].imageUid, images_l.value[i].uid)
      }
    }
    if (images.value.length > 0) {
      loading_d.value = false
      document.getElementById("attachmenDialog").click();
    } else {
      loading_d.value = false
      swal('Record not found', "", "error");
    }

  } else {
    loading_d.value = false
    swal('Record not found', "", "error");
  }
}


async function getFileImg(imageUid, uid) {
  let data = "";
  data = {
    shopUid: search_shopi.value,
    uid: imageUid,
  };
  const payload = data;
  // console.log('fi p : ' + JSON.stringify(payload));
  const response = await storedoc.imgAdminInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('fi r : ' + JSON.stringify(response.data));
        const file = getFileFromBase64(response.data.data.data, response.data.data.name)
        const data = URL.createObjectURL(file);
        let obj = {
          src: data,
          thumbnailImageSrc: data,
          alt: '',
          title: '',
          uid: uid,
          imageUid: imageUid,
        }
        images.value.push(obj)
      }
    }
  }
}

async function removeImage(item, index) {
  swal({
    title: "ลบรายการ",
    text: "คุณต้องการลบรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        deleteFile(item.uid, index);
      }
    }
  });
}

function getFileFromBase64(string64, fileName) {
  var ext = fileName.split('.').pop();
  let type = '';
  let trimmedString = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  } else if (ext === 'bmp') {
    type = 'image/bmp'
  }
  if (type !== 'image/bmp') {
    trimmedString = string64.replace('dataimage/jpegbase64', '');
  } else {
    string64.replace('data:image/bmp;base64,', '');
  }

  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }

  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}


async function updateCollateral(item) {
  versionColl.value = ''
  await getCollecteralInfo(item)
  if (versionColl.value !== '') {
    let data = "";
    data = {
      groupUid: search_groupt.value,
      shopUid: search_shopt.value,
      uid: item.uid,
      weight: item.weight,
      pawnValue: item.pawnValue,
      newPawnValue: item.newPawnValue,
      tmpPawnValue: item.tmpPawnValue,
      tmpNewPawnValue: item.tmpNewPawnValue,
      fullValue: item.fullValue,
      diamondQuantity: item.diamondQuantity,
      quantity: item.quantity,
      serialNumber: item.serialNumber,
      version: versionColl.value,
      workCaseUid: workcaseDetail_u.value.uid
    };
    const payload = data;
    // console.log('uc p : ' + JSON.stringify(payload));
    const response = await storec.collateralUpdatePlatformFetch(payload);
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          // console.log('uc r : ' + JSON.stringify(response.data));
          swal({
            icon: 'success',
            title: 'บันทึกสำเร็จ',
            text: '',
            target: '#updateWorkcaseModal',
            customClass: {
              container: 'loading-state'
            },
          })
          await updateWorkCaseInfo(payload)
        } else {
          swal(response.data.rtnDesc, "", "error");
        }
      }
    }
  } else {
    swal('บันทึกไม่สำเร็จ', "", "error");
  }

}


async function updateWorkCaseInfo(item) {
  let data = "";
  data = {
    groupUid: search_groupt.value,
    shopUid: search_shopt.value,
    uid: item.workCaseUid,
  };
  const payload = data;
  // console.log('wc p : ' + JSON.stringify(payload));
  const response = await storew.workCaseinfoAdminFetch(payload);
  // console.log('wc r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail_u.value = response.data.data
        listcoll.value = response.data.data.ticket.collaterals
      }
    }
  }
}


async function deleteFile(id, index) {
  let data = "";
  data = {
    uid: id,
    shopUid: search_shopi.value,
  };
  const payload = data;
  // console.log("delf p : " + JSON.stringify(payload));
  const response = await storedoc.deleteTkImgFetch(payload);
  // console.log("delf r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        images.value.splice(index, 1);
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function getCollecteralInfo(item) {
  let data = "";
  data = {
    groupUid: search_groupt.value,
    shopUid: search_shopt.value,
    uid: item.uid,
  };
  const payload = data;
  // console.log('ci p : ' + JSON.stringify(payload));
  const response = await storec.collateralInfoPlatformFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('ci r : ' + JSON.stringify(response.data));
        versionColl.value = response.data.data.version
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}

async function getHistoryByRefnumber() {
  listhistory.value = []
  let data = "";
  data = {
    index: 0,
    size: perPage.value,
    cusUid: '',
    groupUid: search_groupi.value,
    refNumber: tk_searchi.value.trim(),
    shopUid: search_shopi.value,
    fromDate: '',
    toDate: '',
    type: '',
    serialNumber: '',
    status: '',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: '',
    active: 'NONE',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
    postpone: 'NONE',
  };
  const payload = data;
  // console.log('wcs p : ' + JSON.stringify(payload));
  const response = await storew.workCaseHistoryFetch(payload);
  // console.log('wcs r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function updatePagination() {
  listhistory.value = []
  totalQuantity.value = 0;
  totalPawnValue.value = 0;
  totalWeight.value = 0
  totalInterest.value = 0
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    cusUid: '',
    groupUid: search_groupi.value,
    refNumber: tk_searchi.value.trim(),
    shopUid: search_shopi.value,
    fromDate: '',
    toDate: '',
    type: '',
    serialNumber: '',
    status: '',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: '',
    active: 'NONE',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
    postpone: 'NONE',
  };
  const payload = data;
  const response = await storew.workCaseHistoryFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalQuantity.value = response.data.data.ext.quantity;
        totalPawnValue.value = response.data.data.ext.pawnValue;
        totalWeight.value = response.data.data.ext.weight;
        totalInterest.value = response.data.data.ext.roundInterest;
      }
    }
  }

}


async function openDetail(item) {
  workcaseInfo.value = null
  let data = "";
  data = {
    groupUid: search_groupt.value,
    shopUid: search_shopt.value,
    uid: item.workCaseUid,
  };
  const payload = data;
  // console.log('wc p : ' + JSON.stringify(payload));
  const response = await storew.workCaseinfoAdminFetch(payload);
  // console.log('wc r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseInfo.value = response.data
        if (workcaseInfo.value !== null) {
          document.getElementById("workcaseInfo").click();
        } else {
          swal('Record not found', "", "error");
        }
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function deleteLunchItems(item) {
  swal({
    title: "ลบรายการ",
    text: "คุณต้องการลบรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        deleteQ(item)
      }
    }
  });
}

async function getlaunchQList() {
  currentPage_l.value = 1
  listlunch_q.value = []
  let data = "";
  data = {
    index: currentPage_l.value - 1,
    size: perPage_l.value,
    groupUid: search_groupl.value,
    shopUid: search_shopl.value,
  };
  const payload = data;
  // console.log('ci p : ' + JSON.stringify(payload));
  const response = await storewt.launchQListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('ci r : ' + JSON.stringify(response.data));
        listlunch_q.value = response.data.data.list
        totalRows_l.value = response.data.data.ext.total
        totalRows_sl.value = formatNumberString(totalRows_l.value)
      
      }
    }
  }
}


async function updatePaginationL() {
  listlunch_q.value = []
  let data = "";
  data = {
    index: currentPage_l.value - 1,
    size: perPage_l.value,
    groupUid: search_groupl.value,
    shopUid: search_shopl.value,
  };
  const payload = data;
  // console.log('ci p : ' + JSON.stringify(payload));
  const response = await storewt.launchQListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('ci r : ' + JSON.stringify(response.data));
        listlunch_q.value = response.data.data.list
        totalRows_l.value = response.data.data.ext.total
        totalRows_sl.value = formatNumberString(totalRows_l.value)
      }
    }
  }
}


async function reLunchItems(item) {
  swal({
    title: "Re Launch รายการ",
    text: "คุณต้องการRe Launchรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        reLaunch(item)
      }
    }
  });
}


async function getrelaunchList() {
  currentPage_r.value = 1
  listrelunch_q.value = []
  let data = "";
  data = {
    index: currentPage_r.value - 1,
    size: perPage_r.value,
    groupUid: search_groupr.value,
    shopUid: search_shopr.value,
  };
  const payload = data;
  // console.log('ci p : ' + JSON.stringify(payload));
  const response = await storewt.failRecordListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('ci r : ' + JSON.stringify(response.data));
        listrelunch_q.value = response.data.data.list
        totalRows_r.value = response.data.data.ext.total
        totalRows_sr.value = formatNumberString(totalRows_r.value)
      }
    }
  }
}


async function updatePaginationR() {
  listrelunch_q.value = []
  let data = "";
  data = {
    index: currentPage_r.value - 1,
    size: perPage_r.value,
    groupUid: search_groupr.value,
    shopUid: search_shopr.value,
  };
  const payload = data;
  // console.log('ci p : ' + JSON.stringify(payload));
  const response = await storewt.failRecordListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('ci r : ' + JSON.stringify(response.data));
        listrelunch_q.value = response.data.data.list
        totalRows_r.value = response.data.data.ext.total
        totalRows_sr.value = formatNumberString(totalRows_r.value)
      }
    }
  }
}


async function deleteQ(item) {
  let uids = []
  uids.push(item.uid)
  let data = "";
  data = {
    uids: uids,
    groupUid: search_groupl.value,
    shopUid: search_shopl.value,
  };
  const payload = data;
  // console.log("delf p : " + JSON.stringify(payload));
  const response = await storewt.deleteQFetch(payload);
  // console.log("delf r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await getlaunchQList()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function reLaunch(item) {
  let uids = []
  uids.push(item.uid)
  let data = "";
  data = {
    uids: uids,
    groupUid: search_groupr.value,
    shopUid: search_shopr.value,
  };
  const payload = data;
  // console.log("delf p : " + JSON.stringify(payload));
  const response = await storewt.reLaunchFetch(payload);
  // console.log("delf r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await getrelaunchList()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}


async function getQueueInfo(item) {
  // console.log('detailPayment : ' + item);
  queueInfo.value = null
  let data = "";
  data = {
    uid: item.uid,
  };
  const payload = data;
  const response = await storewt.launchQInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        queueInfo.value = response.data.data
        if (queueInfo.value !== null) {
          document.getElementById("pgInfo").click();
        } else {
          swal('Record not found', "", "error");
        }
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function getQueueFInfo(item) {
  // console.log('detailPayment : ' + item);
  queueInfo.value = null
  let data = "";
  data = {
    uid: item.uid,
  };
  const payload = data;
  const response = await storewt.launchFInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        queueInfo.value = response.data.data
        if (queueInfo.value !== null) {
          document.getElementById("pgInfo").click();
        } else {
          swal('Record not found', "", "error");
        }
      } else {
        swal(response.data.rtnDesc, "", "error");
      }
    }
  }
}


async function openException(item) { 
  exceptionInfo.value = item.exception
  document.getElementById("exceptionInfo").click();
}



async function setfirstTab() {
  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
}


async function setsecondTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.add('show', 'active')
  }
}

async function setthirddTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.add('show', 'active')
  }
}


async function setfourthTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.add('show', 'active')
  }
}


async function setfifthTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3-tab")) {
    document.getElementById("tab3-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab3")) {
    document.getElementById("tab3").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4-tab")) {
    document.getElementById("tab4-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab4")) {
    document.getElementById("tab4").classList.remove('show', 'active')
  }

  if (document.getElementById("tab5-tab")) {
    document.getElementById("tab5-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab5")) {
    document.getElementById("tab5").classList.add('show', 'active')
  }

  
}

onMounted(() => {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});
</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}
</style>
